import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PolicyIcon from '@mui/icons-material/Policy';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { Grid, MenuItem } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

interface Window {
  zE: any;
}

declare const window: Window;

interface Props {
  onClose: () => void;
}

export const SupportMenuItems: React.FC<React.PropsWithChildren<Props>> = ({ onClose }) => {
  const navigate = useNavigate();

  const openZendesk = () => {
    if (window.zE('webWidget:get', 'display') === 'hidden') {
      window.zE.activate();
    } else {
      window.zE.hide();
    }
  };

  return (
    <>
      <MenuItem
        onClick={() => {
          navigate('/privacy-policy', { state: { fromExternalLink: false } });
          onClose();
        }}
      >
        <Grid container spacing={2}>
          <Grid item>
            <PrivacyTipIcon />
          </Grid>
          <Grid item>Privacy Policy</Grid>
        </Grid>
      </MenuItem>
      <MenuItem
        onClick={() => {
          navigate('/terms-and-conditions', { state: { fromExternalLink: false } });
          onClose();
        }}
      >
        <Grid container spacing={2}>
          <Grid item>
            <PolicyIcon />
          </Grid>
          <Grid item>Terms of Use</Grid>
        </Grid>
      </MenuItem>
      <MenuItem
        onClick={() => {
          openZendesk();
          onClose();
        }}
      >
        <Grid container spacing={2}>
          <Grid item>
            <AlternateEmailIcon />
          </Grid>
          <Grid item>Contact Us</Grid>
        </Grid>
      </MenuItem>
    </>
  );
};
